import {login} from "@/api/login/user"
import TokenStore from "@/utils/tokenStore";
import UserInfoStore from "@/utils/UserInfoStore";

const state = {
    token: TokenStore.getToken('operators'),
    info: UserInfoStore.getInfo()
};

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token
    },
    SET_INFO(state, info) {
        state.info = info;
    }
};

const actions = {
    login({commit}, userInfo) {
        return new Promise((resolve, reject) => {
            login(userInfo).then(res => {
                commit('SET_TOKEN', res.access_token);
                TokenStore.setToken("operators", res.access_token);
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    setInfo({commit}, info) {
        return new Promise(resolve => {
            commit('SET_INFO', info);
            UserInfoStore.setInfo(info)
            resolve()
        })
    },
    logout({commit}) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            TokenStore.removeToken("operators");
            UserInfoStore.removeInfo();
            resolve()
        })
    }
};

export default {
    namespace: true,
    state,
    mutations,
    actions
}
